// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c8aa3516","210":"d3ca7db3","342":"5cc547f0","393":"5d19defc","475":"5db76b1f","498":"68e20e66","538":"9e0e19f8"}[chunkId] + ".chunk.js";
};